import { AxiosBase } from "./config/axiosBase.instance"

export const getWardAPI = (districtId: string) => {
   return AxiosBase.get("/ward/district/" + districtId)
}
